import { AfterViewInit, Component, ElementRef, Input, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { RadiosKeyValue } from './radio-input-group';
import tippy, { Instance, MultipleTargets, Props } from 'tippy.js';

@Component({
  selector: 'libero-radio-input-group',
  templateUrl: './radio-input-group.component.html',
  styleUrls: ['./radio-input-group.component.scss'],
  standalone: false
})
export class RadioInputGroupComponent implements AfterViewInit {
  @Input() public formName!: AbstractControl;
  @Input() public availableValues!: RadiosKeyValue[];
  @Input() public disabled = false;
  @Input() public cyId = ''
  @Input() public efektikaRestrictedPeriods = false;

  @ViewChildren('radioOption') private radioOptions!: QueryList<ElementRef>;
  @ViewChild('tooltipDisabledPeriodForEfektikaTooltip') public tooltipDisabledPeriodForEfektikaContent?: ElementRef;
  private tooltipInvestmentPeriodsInstances: Instance<Props>[] | null = null;

  public componentId = '';

  public constructor(
    public elementRef: ElementRef<HTMLElement>,
  ) {
    const randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
    this.componentId = randLetter + Date.now();
  }

  public selected(newValue: RadiosKeyValue): void {
    this.formName.patchValue(newValue);
    this.formName.markAsTouched();
    this.formName.markAsDirty();
  }

  public isSpecificRadioDisabled(radioData: RadiosKeyValue): boolean {
    return radioData.disabled;
  }

  private initEfektikaPeriodsTooltip(): void {
    if (!this.efektikaRestrictedPeriods) return;

    if(this.tooltipInvestmentPeriodsInstances) {
      this.tooltipInvestmentPeriodsInstances.forEach(i => i.destroy());
      this.tooltipInvestmentPeriodsInstances = null;
    }
    if (this.tooltipDisabledPeriodForEfektikaContent) {
      this.tooltipInvestmentPeriodsInstances = tippy(
        this.radioOptions.toArray()
          .filter(item => (item.nativeElement.getAttribute('data-display-efektika-tooltip') as string | null) === 'false')
          .map(item => item.nativeElement) as MultipleTargets,
        {
          content: this.tooltipDisabledPeriodForEfektikaContent.nativeElement.innerHTML,
          allowHTML: true,
          placement: 'auto',
        }
      ) as Instance<Props>[];
    }
  }

  public ngAfterViewInit(): void {
    this.initEfektikaPeriodsTooltip();
  }
}
